import React from 'react';
import Header from '../../../../components/layout/headers/Header';
import DynamicNavigation from "../../../../components/layout/navigation/DynamicNavigation";
import BanksTable from './BanksTables.jsx';

const ManageBanks = () => {

    return (
        <>
            <Header />
            <DynamicNavigation />
            <div className="content-body">
                <div className="w-full px-4">
                    <BanksTable />
                </div>
            </div>
        </>
    );
};

export default ManageBanks;
